import {
    Box,
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';

const ROW_WIDTHS = ['18px', '55%', '40%', '75px', '95px', '80px', '70px', '60px'];

interface Props {
    rows?: number;
    cols?: number;
}

const TablePageSkeleton = ({ rows = 8, cols = 6 }: Props) => (
    <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
            <Box>
                <Skeleton variant="text" width={220} height={44} />
                <Skeleton variant="text" width={165} height={20} sx={{ mt: 0.5 }} />
            </Box>
            <Skeleton variant="rounded" width={190} height={36} />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', boxShadow: 'none', overflow: 'auto' }}>
            <Table>
                <TableHead sx={{ bgcolor: 'background.default' }}>
                    <TableRow>
                        {Array.from({ length: cols }).map((_, i) => (
                            <TableCell key={i}>
                                <Skeleton variant="text" width={ROW_WIDTHS[i] ?? '70px'} />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: rows }).map((_, rowIdx) => (
                        <TableRow key={rowIdx}>
                            {Array.from({ length: cols }).map((_, colIdx) => (
                                <TableCell key={colIdx}>
                                    <Skeleton
                                        variant="text"
                                        width={colIdx === 0 ? 18 : ROW_WIDTHS[colIdx] ?? '70px'}
                                        height={colIdx === 3 || colIdx === 4 ? 28 : 20}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
);

export default TablePageSkeleton;
